import { useQuery } from "react-query";
import { getNewNotificationCount } from "services/notification.service";

export default function useNewNotificationCount() {
  return useQuery(
    "new-notification-count",
    async () => await getNewNotificationCount()
  );
}
